import React, { useState } from 'react'
import './styles/tooltip.scss'

const Tooltip = (props) => {
    const {
        text, cssClass, style, direction, isNew, children,
    } = props

    let componentClass = 'uc-tooltip '
    componentClass += cssClass ? ` ${cssClass}` : ''
    componentClass += direction ? ` ${direction}` : ''

    let newComponentClass = 'tooltip-container '
    newComponentClass += cssClass ? ` ${cssClass}` : ''

    let tooltipClass = 'tooltip-text'
    tooltipClass += direction ? ` ${direction}` : ''

    const [showTooltip, setShowTooltip] = useState(false)

    const handleMouseEnter = () => {
        setShowTooltip(true)
    }

    const handleMouseLeave = () => {
        setShowTooltip(false)
    }

    if (isNew) {
        return (
            <div
                className={newComponentClass}
                style={style}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {children}
                {showTooltip && <p className={tooltipClass}>{text}</p>}
            </div>
        )
    }

    return (
        <span
            className={componentClass}
            style={style}
        >
            {text}
        </span>
    )
}

export default Tooltip
